export { TicketForm } from './TicketForm'
export { MyTickets } from './MyTickets'
export { Ticket } from './Ticket'

export const TicketStates = {
    WAITING: 'Waiting',
    ADMIN_ANSWERED: 'Admin answered',
    USER_ANSWERED: 'You answered',
    SOLVED: 'Solved',
    CLOSED: 'Closed',
}

export const TicketTypes = {
    PurchaseProblem: 'Problem purchasing product(s)',
    UndeliveredProduct: 'Product(s) not delivered',
    PaymentProblem: 'Problem with Payment',
    Other: 'Other'
}